import type {EditedProperty} from 'typings/portaro.be.types';
import {transferify} from 'shared/utils/data-service-utils';
import type {
    OverallStatsData,
    OverallStatsDataParams,
    PublicStatsData,
    PublicStatsDataParams,
    ZStatsData
} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class StatsDataService {
    public static serviceName = 'statsDataService';

    public static readonly PUBLIC_STATS_ROUTE = 'stats/public';
    public static readonly PUBLIC_STATS_FORM_SETTINGS_ROUTE = 'stats/public/formSettings';
    public static readonly OVERALL_STATS_ROUTE = 'stats/overall';
    public static readonly OVERALL_STATS_FORM_SETTINGS_ROUTE = 'stats/overall/formSettings';
    public static readonly Z_STATS_ROUTE = 'stats/z';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getPublicStats(params?: PublicStatsDataParams): Promise<PublicStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.PUBLIC_STATS_ROUTE)
            .get({...transferify(params)});
    }

    public async getPublicStatsFormSettings(): Promise<EditedProperty[]> {
        return this.ajaxService
            .createRequest(StatsDataService.PUBLIC_STATS_FORM_SETTINGS_ROUTE)
            .get();
    }

    public async getOverallStats(params?: OverallStatsDataParams): Promise<OverallStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.OVERALL_STATS_ROUTE)
            .get({...transferify(params)});
    }

    public async getOverallStatsFormSettings(): Promise<EditedProperty[]> {
        return this.ajaxService
            .createRequest(StatsDataService.OVERALL_STATS_FORM_SETTINGS_ROUTE)
            .get();
    }

    public async getZStatsData(): Promise<ZStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.Z_STATS_ROUTE)
            .get();
    }
}